import React from 'react';
import { observer } from 'mobx-react';
import { getAgentIdsForTraceResults } from 'app/stores/synthetics/utils';
import TestPath from 'app/views/synthetics/components/TestPath';
import LoadingPanel from './LoadingPanel';

@observer
export default class PathPanel extends React.Component {
  render() {
    const { test, testResults, traceroutes, agents } = this.props;
    const { loadingAlarmResults, loadingTraceResults, displayOptions, hasTraceResults } = testResults;
    const { allowExport } = displayOptions;
    const isParentTest = !agents; // subtest trace results explicit provide the agent id
    const agentIds = agents || getAgentIdsForTraceResults(test, []);

    return (
      <LoadingPanel
        test={test}
        testResults={testResults}
        // since parent tests also consider agents and targets associated with alarms, we wait for that too
        loading={(isParentTest && loadingAlarmResults) || (loadingTraceResults && !hasTraceResults)}
      >
        <TestPath
          testResults={testResults}
          traceroutes={traceroutes}
          agents={agentIds}
          isPreview={test.isPreview}
          allowExport={allowExport}
          useLocalIp={test.get('config.useLocalIp')}
        />
      </LoadingPanel>
    );
  }
}
